import base from '@/http/url_base';

export default {
  ACTIVITE: base.API_RH + '/candidature-activites',
  APPRECIER: base.API_RH + '/candidature-activites/apprecier',
};
